import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./Pages/Home/Home";
import CategoryPage from "./Pages/Category/Category";
import Cart from "./Pages/Cart/Cart";
import NotFound from "./Pages/NotFound/NotFound";
import AdminLayout from "./Pages/Admin/AdminLayout";
import Dashboard from "./Pages/Admin/Dashboard/Dashboard";
import ManageCategories from "./Pages/Admin/Categories/ManageCategories";
import ManageProducts from "./Pages/Admin/Products/ManageProducts";
import ManageSettings from "./Pages/Admin/Settings/ManageSettings";
import ManageOrders from "./Pages/Admin/Orders/ManageOrders";
import ManagePromotions from "./Pages/Admin/Promotions/ManagePromotions";

import Login from "./Pages/Admin/Login/Login";
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute";
import MainLayout from "./Components/MainLayout/MainLayout";
import About from "./Pages/About/About";
import Install from "./Pages/Install/Install";
import "./Css/Reset.css";
import "./Css/Global.css";
import { useServerStatus } from "./Modules/Contexts/ServerStatusContext";
import ServerErrorOverlay from "./Components/ServerErrorOverlay/ServerErrorOverlay";
import Loader from "./Components/Loader/Loader";

const App = () => {
  const { isServerOnline, isLoading } = useServerStatus();

  if (isLoading) {
    return <Loader />;
  }

  if (!isServerOnline) {
    return <ServerErrorOverlay />;
  }

  return (
    <Routes>
      {/* Маршруты с общим Layout */}
      <Route element={<MainLayout />}>
        <Route path="/*" element={<NotFound />} />
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/about" element={<About />} />
        <Route path="/install" element={<Install />} />
        <Route path="/login" element={<Login />} />
      </Route>

      <Route path="/admin" element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route index element={<Navigate to="dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<ManageOrders />} />
          <Route path="categories" element={<ManageCategories />} />
          <Route path="products" element={<ManageProducts />} />
          <Route path="promotions" element={<ManagePromotions />} />
          <Route path="settings" element={<ManageSettings />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
